import React, { useState } from 'react';
import { pdfjs, Document, Page } from 'react-pdf';
import Modal from './Modal';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDF = ({
  srcName,
  title,
  isOpen,
  onClose,
}) => {
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <Modal
      isOpen={isOpen}
      isClosable={true}
      onClose={onClose}
      title={title}
      size='full'
      Content={(
        <>
          <div>
            <Document
              file={srcName}
              onLoadSuccess={onDocumentLoadSuccess}
              renderMode='svg'
            >
              {new Array(numPages).fill([]).map((item, index) => (
                <Page width={300} pageNumber={index + 1} key={index}/>
              ))}
            </Document>
          </div>
        </>
      )}
    />
  );
};

export default PDF;